import { on } from 'delegated-events';
import createPills from './create-pills';
import { isVisible, showLoader, hideLoader, whenIdle } from './utils/utils';
import { whenPjaxReady } from './pjax-code';

// ten sam prog co @desktop w LESS: powyzej filtry stoja jako kolumna listingu,
// ponizej otwieraja sie jako kanwa spod przycisku "Filtruj"
const desktopQuery = window.matchMedia('(min-width: 1280px)');

let filterPromise = null;
let filterElement = null;
let behaviorsAttached = false;

function closeFilter() {
    document.body.classList.remove('overlay-visible');
    document.body.classList.remove('show-filter');
}

// loading = szkielet, ready = formularz, empty = listing bez filtrow (kolumna znika)
function setMountState(mount, state) {
    if (!mount) return;

    mount.setAttribute('data-filter-state', state);
    mount.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
}

function clearMount(mount) {
    if (!mount) return;

    mount.innerHTML = '';
    setMountState(mount, 'empty');
}

function openDropdowns() {
    let allChildren = document.querySelectorAll("#filter .parent-li");
    allChildren.forEach(li => {
        const mainChecked = li.querySelector("& > input:checked");
        let childrenChecked = li.querySelector('.common-children-wrapper input:checked');
        if (mainChecked || !childrenChecked) return;

        const dropdownToggle = li.querySelector('.accordion-trigger');
        if (dropdownToggle) dropdownToggle.classList.add('info-visible');
    });
}

function attachFilterBehaviors(filter) {
    if (behaviorsAttached) return;
    behaviorsAttached = true;

    if (filter.querySelector('.accordion-trigger')) {
        openDropdowns();
    }

    const closeTop = filter.querySelector('.close-filter');
    if (closeTop) closeTop.addEventListener('click', closeFilter);

    const closeBottom = filter.querySelector('.close-filter-bottom > span');
    if (closeBottom) closeBottom.addEventListener('click', closeFilter);

    // akordeon i w kolumnie (desktop), i w kanwie (mobile)
    filter.querySelectorAll('.gs-filtr-container > strong').forEach(strong => {
        strong.addEventListener('click', function () {
            this.parentElement.classList.toggle('show-list');
        });
    });
}

// grupy startuja zwiniete; rozwijamy te z aktywnym wyborem. .any-selected ustawia createPills -
// cena dostaje ja tylko zawezona (formularz zawsze wysyla priceFrom/priceTo z min/max)
function openSelectedGroups(filter) {
    filter.querySelectorAll('.gs-filtr-container > strong.any-selected').forEach(strong => {
        strong.parentElement.classList.add('show-list');
    });
}

// bez kolumny filtrow (mobile) sortowanie i ilosc na stronie nie stoja w pasku nad produktami,
// tylko w kanwie "Filtry i sortowanie" - pod naglowkiem, w tej kolejnosci
const CANVAS_PICKER_TYPES = ['sort', 'pageSize'];

function bindCanvasPicker(picker) {
    const dropdownButton = picker.querySelector('.dropdown-button');
    if (dropdownButton) {
        dropdownButton.addEventListener('click', function () {
            picker.classList.toggle('show-dropdown-rwd');
        });
    }

    document.addEventListener('click', function (event) {
        if (!picker.contains(event.target) && isVisible(picker)) {
            picker.classList.remove('show-dropdown-rwd');
        }
    });
}

function mergePickersIntoFilter(filter) {
    if (desktopQuery.matches) return;

    let anchor = filter.querySelector('.filter-top');

    CANVAS_PICKER_TYPES.forEach(type => {
        const selector = `.dropdown-picker[data-dropdown-type="${type}"]`;
        const toolbarPicker = document.querySelector(`.dropdowns-wrapper ${selector}`);
        const canvasPicker = filter.querySelector(selector);

        // juz w kanwie - kopia z paska (np. po podmianie listingu pjaxem) zdublowalaby id radii
        if (canvasPicker) {
            if (toolbarPicker) toolbarPicker.remove();
            anchor = canvasPicker;
            return;
        }

        if (!toolbarPicker) return;

        const picker = toolbarPicker.cloneNode(true);
        toolbarPicker.remove();

        // radia to tylko UI (wartosc idzie przez ukryte sort/pageSize) - atrybut form bez
        // pasujacego formularza wyjmuje je z #filter.elements, wiec pjax nie dopisze ich do URL
        picker.querySelectorAll('input[type="radio"]').forEach(radio => {
            radio.setAttribute('form', 'listing-picker-ui');
        });

        anchor.insertAdjacentElement('afterend', picker);
        anchor = picker;
        bindCanvasPicker(picker);
    });
}

function buildFetchUrl(trigger) {
    const source = trigger.getAttribute('data-filter-source');
    const id = trigger.getAttribute('data-filter-id');
    const query = trigger.getAttribute('data-filter-query');

    if (!source) return null;

    const params = new URLSearchParams();
    params.set('source', source);
    if (id) params.set('id', id);
    if (query) params.set('q', query);

    const pageParams = new URLSearchParams(window.location.search);
    ['feature', 'trait', 'producer', 'common', 'category', 'promo', 'campaign', 'available'].forEach(key => {
        pageParams.getAll(key).forEach(value => {
            if (value) params.append(key, value);
        });
    });
    ['priceFrom', 'priceTo', 'sort', 'pageSize'].forEach(key => {
        const value = pageParams.get(key);
        if (value) params.set(key, value);
    });

    return `/filters/render?${params.toString()}`;
}

async function fetchAndInject(trigger, withLoader) {
    const url = buildFetchUrl(trigger);
    if (!url) return null;

    if (withLoader) showLoader();

    try {
        const response = await fetch(url, {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        const html = response.ok ? await response.text() : '';

        // mount czytany dopiero po fetchu - pjax mogl w miedzyczasie podmienic #pjax-container
        const mount = document.getElementById('filter-mount');
        if (!mount) return null;

        // pusta odpowiedz = listing bez filtrow (FiltersController oddaje EmptyResult)
        if (!html.trim()) {
            clearMount(mount);
            return null;
        }

        mount.innerHTML = html;

        const filter = mount.querySelector('#filter');
        if (!filter) {
            clearMount(mount);
            return null;
        }

        filterElement = filter;
        setMountState(mount, 'ready');

        attachFilterBehaviors(filter);

        const pjax = await whenPjaxReady();
        if (pjax && typeof pjax.parseDOM === 'function') {
            pjax.parseDOM(document);
        }

        const priceModule = await import('./price-filtering');
        priceModule.default();

        const narrowModule = await import('./listing/filter-narrow-down');
        narrowModule.default();

        createPills();
        openSelectedGroups(filter);

        // kolumna gotowa - m.in. sticky-filters przelicza polozenie grup
        document.dispatchEvent(new CustomEvent('filters:ready'));

        if (window.lazyLoadInstance) window.lazyLoadInstance.update();

        return filter;
    } catch (err) {
        console.error('Filter load failed', err);
        clearMount(document.getElementById('filter-mount'));
        return null;
    } finally {
        if (withLoader) hideLoader();
    }
}

function ensureFilter(trigger, withLoader = true) {
    const existing = document.getElementById('filter');
    if (existing) return Promise.resolve(existing);

    if (filterPromise) return filterPromise;

    filterPromise = fetchAndInject(trigger, withLoader).then(result => {
        if (!result) filterPromise = null;
        return result;
    });

    return filterPromise;
}

// #filter-mount siedzi w #pjax-container, wiec kazda podmiana listingu kasuje wstrzyknieta
// kolumne (serwer oddaje w tym miejscu sam szkielet). Formularz trzymamy w pamieci i wpinamy
// z powrotem - zachowuje zaznaczenia, suwak ceny i handler submitu podpiety przez pjaxa.
function restoreFilter() {
    const mount = document.getElementById('filter-mount');
    if (!mount) return;

    if (filterElement) {
        if (document.contains(filterElement)) return;

        mount.innerHTML = '';
        mount.appendChild(filterElement);
        setMountState(mount, 'ready');

        // swiezy pasek z serwera znow ma pickery - na mobile ich miejsce jest w kanwie
        mergePickersIntoFilter(filterElement);
        return;
    }

    // nie ma czego wpiac: albo pobieranie wciaz trwa (swiezy szkielet zostaje),
    // albo listing nie ma filtrow i szkielet musi zniknac, zeby nie pulsowal w nieskonczonosc
    if (!filterPromise) clearMount(mount);
}

export default function () {
    const trigger = document.querySelector('.filter-trigger[data-filter-source]');
    if (!trigger) return;

    // rejestracja synchroniczna, wiec ten handler idzie przed handlerami z pjax-code
    // (tamte wpinaja sie dopiero po dociagnieciu chunka pjaxa) - reszta widzi filtr w DOM
    document.addEventListener('pjax:complete', restoreFilter);

    on('click', '.filter-trigger', async function (e) {
        e.preventDefault();

        const filter = await ensureFilter(this, true);
        if (!filter || desktopQuery.matches) return;

        document.body.classList.add('overlay-visible');
        document.body.classList.add('show-filter');
        mergePickersIntoFilter(filter);
    });

    on('click', '#filter .dropdown-listing > span', function () {
        this.closest('.dropdown-picker').classList.remove('show-dropdown-rwd');
    });

    // desktop dociaga kolumne sam (szkielet w #filter-mount sygnalizuje ladowanie);
    // na mobile - dopiero klikniecie w "Filtruj", zeby nie ruszac transferu bez potrzeby
    const autoLoad = () => {
        if (!desktopQuery.matches) return;

        const currentTrigger = document.querySelector('.filter-trigger[data-filter-source]');
        if (currentTrigger) whenIdle(() => ensureFilter(currentTrigger, false));
    };

    autoLoad();
    desktopQuery.addEventListener('change', autoLoad);
}
